const PackageData = [
    {
        type: 'Basic',
        price: 1000,
        time: '3 Days',
        size: '3 Pages'
    },
    {
        type: 'Premium',
        price: 2000,
        time: '2 Days',
        size: '5 Pages'
    },
    {
        type: 'Business',
        price: 3000,
        time: '5 Days',
        size: '8 Pages'
    }
]

export default PackageData